import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  // apiKey: "AIzaSyBtWfMcElhOeZC3MB9P-pX_y6raux9rw9Y",
  // authDomain: "imcrinox-test-projects.firebaseapp.com",
  // databaseURL: "https://imcrinox-test-projects-default-rtdb.firebaseio.com",
  // projectId: "imcrinox-test-projects",
  // storageBucket: "imcrinox-test-projects.appspot.com",
  // messagingSenderId: "425691223771",
  // appId: "1:425691223771:web:7389965e72d5f9d4741efe",
  // measurementId: "G-X8MKBQXN4Q",
  apiKey: "AIzaSyBe8zFvNtC2YLR8NRN3Mac5wiku70dPpgc",
  authDomain: "urxprt-75b83.firebaseapp.com",
  databaseURL: "https://urxprt-75b83-default-rtdb.firebaseio.com",
  projectId: "urxprt-75b83",
  storageBucket: "urxprt-75b83.firebasestorage.app",
  messagingSenderId: "660820760524",
  appId: "1:660820760524:web:9873aab13d98d4891d6f69",
  measurementId: "G-SEEPC83LF7"
};

// ✅ Initialize Firebase ONCE
const app = initializeApp(firebaseConfig);

// ✅ Correct services
export const auth = getAuth(app);
export const storage = getStorage(app);
export const fireStore = getFirestore(app); // 🔥 THIS FIXES YOUR ERROR

export default app;
